<template>
	<div id="main">
		<dv-loading v-if="false">Loading...</dv-loading>
		<StaticHeader @changeCountState="changeCountState" @changeMouth="changeMouth"></StaticHeader>
		<div class="statistic-content">
		
			<div class="statisticOneContent">
				<div>
					<dv-border-box-1>
						<!-- 雷达图 -->
						<RadarChart id='myRadarChart' ref="RadarChart" title="文档情况统计"></RadarChart>
					</dv-border-box-1>
				</div>
				<div style="margin:0 10px" class="OneCenterContent">
					<div class="OneCenterContent-item">
						<dv-border-box-13>
							<p>文档处理数量</p>
							<p>
								<span>
									<count-to
									:start-val="0"
									:end-val="allData.fileCount"
									:duration="5000"
									class="fontG"
								/></span>
							</p>
							<dv-decoration-6 style="width:50%;height:30px;margin:10px 25% 0 25%" />
						</dv-border-box-13>
					</div>
					<div class="OneCenterContent-item">
						<dv-border-box-13>
							<p>工具使用次数</p>
							<p>
								<span>
									<count-to
									:start-val="0"
									:end-val="allData.useCount"
									:duration="5000"
									class="fontG"
								/></span>
							</p>
							<dv-decoration-6 style="width:50%;height:30px;margin:10px 25% 0 25%" />
						</dv-border-box-13>
					</div>
					<div class="OneCenterContent-item">
						<dv-border-box-13>
							<p class="pv-uv">系统浏览量(PV)  
								<el-tooltip class="item" effect="light" popper-class="pvAndUvTip"   placement="right">
									<div slot="content">即通常说的Page View(PV)，用户每打开一个网站页面就被记录1次。<br />用户多次打开同一页面，浏览量值累计。</div>	
								<i class="el-icon-question" style="cursor: pointer;"></i>
								</el-tooltip>
								</p>
							<p>
								<span>
									<count-to
									:start-val="0"
									:end-val="allData.pv"
									:duration="5000"
									class="fontG"
								/></span>
							</p>
							<dv-decoration-6 style="width:50%;height:30px;margin:10px 25% 0 25%" />
						</dv-border-box-13>
					</div>
					<div class="OneCenterContent-item">
						<dv-border-box-13>
							<p class="pv-uv">系统访客量(UV)
								<el-tooltip class="item" effect="light" popper-class="pvAndUvTip" placement="right">
									<div slot="content">一天之内网站的独立访客数(以Cookie为依据)，<br /> 一天内同一访客多次访问您网站只计算1个访客。</div>	
									<i class="el-icon-question" style="cursor: pointer;"></i>
								</el-tooltip>
							</p>
							<p>
								<span>
									<count-to
									:start-val="0"
									:end-val="allData.uv"
									:duration="5000"
									class="fontG"
								/></span>
							</p>
							<dv-decoration-6 style="width:50%;height:30px;margin:10px 25% 0 25%" />
						</dv-border-box-13>
					</div>
				</div>
							<!--  -->
				<div>
					<dv-border-box-1>
						<div style="padding:0 20px">
							<barChart1 ref="top10"></barChart1>
						</div>
					</dv-border-box-1>
				</div>
			</div>
			<div class="statisticTwoContent">
				<div>
					<dv-border-box-1>
						<LineAndpieChart ref="LineAndpieChart"></LineAndpieChart>
					</dv-border-box-1>
				</div>
				<!-- <div style="margin-left:5px;">
					<ScatterChart id='myCharts4' title="文件下载排行"></ScatterChart>
				</div> -->
			</div>
			<div class="statisticThreeContent">
				<div>
					<dv-border-box-1>
							<div class="title">
								<span class="title-title">文档工具使用次数统计报表</span>
								<el-button size="small" type="primary" @click="expotExcel">导出报表</el-button>
							</div>
							<el-table
							class="table" :data="rankingData" height="310">
								<el-table-column
								  label="序号"
									type="index">
								</el-table-column>
								<el-table-column
									prop="toolName"
									label="工具名称"
									align="center">
								</el-table-column>
								<el-table-column
									prop="pv"
									label="浏览量(PV)"
									sortable
									align="center">
								</el-table-column>
								<el-table-column
									prop="uv"
									sortable
									label="访客量(UV)"
									align="center"
									>
								</el-table-column>
								<el-table-column
									prop="useCount"
									sortable
									label="使用次数"
									align="center"
									>
								</el-table-column>
							</el-table>
					</dv-border-box-1>
				</div>
				<div style="margin-left:5px;">
					<!-- <LineChart id='myCharts5' title="用户下载排行" :yData="[320, 239, 132, 342, 390, 230]" :xData="['国士之风','天蓝国风','admin','测试账号','薇薇薇','tianlan']"></LineChart> -->
					<dv-border-box-1>
							<div class="title">
								<span class="title-title">文档工具处理情况实时统计</span>
								<!-- <el-button size="small" type="primary" @click="expotExcel">导出报表</el-button> -->
							</div>
							<p class="opeanCount">正在处理的文件数量: <em>{{ operateCount }}个</em></p>
							<el-table
							class="table" :data="operateData" height="280">
								<el-table-column
									prop="ip"
									label="访问者ip"
									align="center">
								</el-table-column>
								<el-table-column
									prop="startTime"
									class-name="filename"
									label="处理时间"
									sortable
									align="center">
								</el-table-column>
								<el-table-column
									prop="toolName"
									sortable
									label="文档工具"
									align="center"
									>
								</el-table-column>
								<el-table-column
								class-name="filename"
									prop="filename"
									sortable
									label="文件名称"
									align="center"
									>
								</el-table-column>
								<el-table-column
									label="处理状态"
									align="center"
									>
									<template slot-scope="scope">
											<span>{{ scope.row.status==0||scope.row.status==1 ? '处理中' : scope.row.status==2? '处理完成' : '处理失败' }}</span>
										</template>
								</el-table-column>
							</el-table>
					</dv-border-box-1>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {statisticsAPI } from 'liankong-ui-api'
import BarChartVue from './warningCompontents/barChart.vue';
import StaticHeader from "./conpontents/staticHeader.vue";
import LineChart from './warningCompontents/lineChart.vue';
import ScatterChart from './warningCompontents/scatterChart.vue';
import RadarChart from './warningCompontents/pie.vue';
import LineAndpieChart from './warningCompontents/lineAndpieChart.vue';
import CountTo from "vue-count-to";
import barChart1 from './warningCompontents/barChart1.vue';
import Table from './warningCompontents/table1.vue';
export default {
  name: "Home",
  components: {
	LineChart,
	BarChartVue,
	ScatterChart,
	StaticHeader,
	RadarChart,
	LineAndpieChart,
	CountTo,
	barChart1,
	Table
  },
  data() {
    return {
		allData:{
			fileCount: 0, // 文档处理数量
			pv:0, // 工具浏览量
			useCount: 0, // 工具使用次数
			uv:0 // 工具访客量
		}, 
		monthValue:'',
		countState:'今天',
		operateCount:0,
		operateData:[],
		rankingData:[],
		startDay:'',
		endDay:'',
		timer:null,
		timeRanges:null,
		config:{
				data: [
    {
      name: '天蓝国风',
      value: 55123
    },
    {
      name: '国士之风',
      value: 12022
    },
    {
      name: 'tianlan',
      value: 78932
    },
    {
      name: '薇薇薇',
      value: 63411
    },
	 {
      name: '测试账号1',
      value: 40341
    }, {
      name: '测试账号2',
      value: 33411
    }
  ],
		}
	
    };
  },
  created() {},
  mounted() {
		const startDay = this.getDateTime(0)
		const endDay = this.getDateTime(0)
		this.startDay=startDay
		this.endDay=endDay
		this.queryAllAPI(startDay,endDay)
		this.getOperateList(startDay,endDay)

		this.timer = setInterval(() => {
			this.queryAllAPI(startDay,endDay)
		},120000)
		this.timeRanges = setInterval(() => {
			this.getOperateList(startDay,endDay)
		},120000)
		

		
  },
  methods: {
		queryAllAPI(startDay,endDay,queryType=1){
			this.$refs.RadarChart.getList(startDay,endDay)
			this.getCountStatis(startDay,endDay)
			this.$refs.top10.getTop10(startDay,endDay)
			this.getToolsUseCount(startDay,endDay)
			this.$refs.LineAndpieChart.getList(startDay,endDay,queryType)
		},
		changeMouth(monthValue){
			let yearDate = new Date().getFullYear();
			let startDay = monthValue[0].replace(/YYYY/,yearDate)
			const yearMonth = monthValue[1].replace(/YYYY/,yearDate).substring(0,7)
			let endDay = yearMonth + '-' + this.getDayNum(yearMonth.split('-')[0],yearMonth.split('-')[1])
			let queryType = 3
			this.startDay=startDay
			this.endDay=endDay
			clearInterval(this.timer)
			this.queryAllAPI(startDay,endDay,queryType)
			this.timer = setInterval(() => {
				this.queryAllAPI(startDay,endDay,queryType)
			},120000)
		},
	  getDayNum(year,month){
			 let dayNums = 0
				switch(month){
					case '01':
					case '03':
					case '05':
					case '07':
					case '08':
					case '10':
					case '12':
						dayNums=31;
						break;
					case '04':
					case '06':
					case '09':
					case '11':
						dayNums=30;
						break;
					case '02': this.isLeapYear(year) ? dayNums=29 : dayNums=28;
				}
				return dayNums
		},
		isLeapYear(year){
			if(year%4==0 && year%100!=0 || year%400==0){return true}
			else {return false}
		},
		changeCountState(countState){
			let startDay = ''
			let endDay = ''
			let queryType = 0
			if(countState=='今天'){
				 startDay = this.getDateTime(0)
				 endDay = this.getDateTime(0)
				 queryType = 1
			} else if(countState=='昨天'){
				 startDay = this.getDateTime(1)
				 endDay = this.getDateTime(1)
				 queryType = 1
			} else if(countState=='最近7天'){
				 startDay = this.getDateTime(7)
		     endDay = this.getDateTime(0)
				 queryType = 2
			} else if(countState=='最近30天'){
				 startDay = this.getDateTime(30)
				 endDay = this.getDateTime(0)
				 queryType = 2
			} else {
				return
			}
			this.startDay=startDay
			this.endDay=endDay
			clearInterval(this.timer)
			this.queryAllAPI(startDay,endDay,queryType)
			this.timer = setInterval(() => {
				this.queryAllAPI(startDay,endDay,queryType)
			},120000)
		},
		getDateTime(days){
			let currentDate = new Date(); // 获取当前日期
			currentDate.setDate(currentDate.getDate() - days); // 将当前日期减去30天

			let year = currentDate.getFullYear(); // 获取年份
			let month = currentDate.getMonth() + 1; // 获取月份（注意月份从0开始，需要加1）
			let day = currentDate.getDate(); // 获取日期

			// 格式化日期为字符串（例如：YYYY-MM-DD）
			let formattedDate = `${year}-${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day}`;
			return formattedDate
		},
		getOperateList(startDay,endDay){
			statisticsAPI.statisRealProgress({
					endDay,
					startDay
				}).then(res=>{
					if(res.code==0){
						this.operateData = res.data
						let countFile=0
						res.data.forEach(item => {
								if(item.status==1 || item.status==0){
									countFile++
								}
						});
						this.operateCount = countFile
					} else {
						this.$message.error(res.message)
					}
				})
		},
		expotExcel(){
			window.open(`/api/v1/tool/statis/ranking/export?startDay=${this.startDay}&endDay=${this.endDay}`)
		},
		getCountStatis(startDay,endDay){
				statisticsAPI.toolsStatis({
					endDay,startDay
				}).then(res=>{
					if(res.code==0){
						this.allData = res.data
					} else {
						this.$message.error(res.message)
					}
				})
		},
		getToolsUseCount(startDay,endDay){
			statisticsAPI.statisRanking({
					endDay,startDay
				}).then(res=>{
					if(res.code==0){
						this.rankingData = res.data.records
					} else {
						this.$message.error(res.message)
					}
				})
		}
  },
	destroyed(){
		clearInterval(this.timer)
		clearInterval(this.timeRanges)
	}
};
</script>


<style lang="less">
.pvAndUvTip {
	display: block;
	background: #1f252f !important;
	color: #fff !important;
  .popper__arrow:after {
		border-right-color: #1f252f !important;
	}
}
.count-time-date {
	width: 466px;
	.el-picker-panel__body {
		.el-date-range-picker__content {
			width: auto;
		}
		.el-month-table {
			width: 90%;
		}
		.el-picker-panel__icon-btn {
			display: none
		}
		.is-right {
			display: none;
		}
	}
}
</style>

<style scoped lang="less">
#main {
  width: 100%;
  height: 1350px;
  // min-width: 1850px;
  background: url("../../assets/pageBg.png") no-repeat;
  background-size: 100% 100%;
  overflow: hidden;
  ::v-deep .loading-tip {
    font-size: 23px !important;
    color: aqua;
    font-weight: bold;
  }
  .statistic-content {
    width: 100%;
    height: calc(1850px - 80px);
    padding-top: 20px;
		.count-time {
			// background: #fff;
			.count-time-tip {
				margin-left: 20px;
				font-size: 16px;
				color: #fff;
				font-weight: bold;
				margin-right: 10px;
			}
			.count-time-date {

			}
		}
	.statisticOneContent{
   		padding: 10px;
		clear: both;
		display: grid;
		height: 410px;
		grid-template-columns: 6fr 4fr 5fr;
		.OneCenterContent{
			height: 200px;
			display: grid;
			grid-template-columns: 8fr 8fr;
			/deep/.border-box-content{
				text-align: center;
				height: 200px;
				color:#06f1ef;
				p{
					margin: 0;
				}
				p:nth-child(1){
					font-size: 20px;
					padding-top: 50px;
					margin-bottom: 10px;
				}
				p:nth-child(2){
					font-size: 30px;
				}
			}
			
		}
	}
	.statisticTwoContent{
		margin-bottom: 10px;
		padding: 10px;
		clear: both;
		display: grid;
		height: 410px;
		grid-template-columns: 16fr;

	}
	.statisticThreeContent{
		margin-bottom: 10px;
		padding: 10px;
		clear: both;
		display: grid;
		height: 410px;
		grid-template-columns: 8fr 8fr;
		.title {
			display: flex;
			justify-content: space-between;
			padding: 15px 25px;
			box-sizing: border-box;
			.title-title {
				 font-size: 15px;
				 color: #06f1ef;
				 font-weight: bold;
			}
		}
		.opeanCount {
			margin-block-end: 0;
			margin-block-start: 0;
			color: #fff;
			padding: 10px 25px;
			box-sizing: border-box;
			em {
				font-weight: bold;
				font-size: 18px;
			}
		}
		.table {
			width: 95% !important;
			margin: 0 auto;
			/deep/ .el-table__header {
				// background: red;
				thead th {
					background: #03050c;
					color: #fff;
				}
				
			}
			/deep/ .el-table__body tr {
				background: rgb(15, 19, 37);
				border: 0px;
				color: #fff;
			}
			/deep/ .el-table__cell {
				border: 0px;
			}
			/deep/ .el-table__empty-block {
				background: rgb(15, 19, 37);
				border: 0px;
				color: #fff;
			}
			/deep/ .filename {
				.cell {
					display: inline-block;
					white-space: nowrap; 
					width: 100%; 
					overflow: hidden;
					text-overflow:ellipsis;
				}
			}
			/deep/ .el-table__body tr:hover>td{
				background-color: rgb(15, 19, 37) !important;
			}
			/deep/ .el-table__body-wrapper {
				background: rgb(15, 19, 37);
			}
		} 
		.table::before {
			height: 0;
		}

	}
	.pv-uv {
		position: relative;
		.el-icon-question {
			font-size: 14px;
			cursor: pointer;
			position: absolute;
			margin-top: -3px;
			right: 65px;
		}
	}

    
  }
}
</style>
